<template>
  <div class="create-container">
    <el-dialog
      title="设计图片"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      width="52%"
    >
      <div class="inner">
        <span type="text" class="text-group">文字</span>
        <create-base
          @cUpdateColor="updateColor"
          @cUpdateText="updateText"
          @cUpdateSize="updateSize"
          @cUpdateFamily="updateFamily"
          @cUpdateWeight="updateWeight"
          @cUpdateItalic="updateItalic"
        ></create-base>
        <span type="text" class="text-group">背景</span>
        <create-background @cUpdateBg="updateBg"> </create-background>
        <span type="text" class="text-group">预览</span>
        <preview-canvas ref="previewRef"></preview-canvas>
        <!-- <img :src="src" alt=""> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="success"
          @click="saveBlobCanvas"
          style="background: #009e7d"
          :loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import createBase from "./createBase.vue";
import createBackground from "./createBackground.vue";
import previewCanvas from "./previewCanvas.vue";
export default {
  name: "canvasPicture",
  model: {
    prop: "pickerShow", // 默认是value
    event: "toggleShow", // 默认是input
  },
  props: {
    pickerShow: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    createBase,
    createBackground,
    previewCanvas,
  },

  data() {
    return {
      loading: false,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.pickerShow;
      },
      set(val) {
        this.$emit("toggleShow", val);
      },
    },
  },
  methods: {
    saveBlobCanvas() {
      //   const vm = this
      this.$refs.previewRef.getCanvasImage().then((res) => {
        this.loading = true;
        let file = this.setFormData(res);
        // let file = new File(blob,'XXX.png')
        // file.name = "XXX.png"
        // debugger
        this.$axios
          .post("/aries-api/resource/upload", file)
          .then((response) => {
            this.loading = false;
            this.dialogVisible = false;
            console.log(response);
            if (response.data.result == "0") {
              this.$emit("getData", response.data.data);
            } else {
              this.$emit("getData", []);
            }
          })
          .catch((err) => {
            this.loading = false;
            this.dialogVisible = false;
          });
        // 后续传给后台用
      });
    },
    setFormData(res) {
      var fd = new FormData();
      let file = new File([res.previewBlob],'image.png')
      fd.append("file", file);
      return fd;
    },
    updateColor(val) {
      this.$refs.previewRef.updateCanvas(val, "color");
    },
    updateText(text) {
      this.$refs.previewRef.updateCanvas(text, "text");
    },
    updateSize(size) {
      this.$refs.previewRef.updateCanvas(size, "size");
    },
    updateFamily(family) {
      this.$refs.previewRef.updateCanvas(family, "family");
    },
    updateWeight(weight) {
      this.$refs.previewRef.updateCanvas(weight, "weight");
    },
    updateBg(image) {
      this.$refs.previewRef.updateCanvas(image, "image");
    },
    updateItalic(italic){
      this.$refs.previewRef.updateCanvas(italic, "italic");

    }
  },
};
</script>

<style lang="scss">
.create-container {
  .text-group {
    text-align: left;
    width: 100%;
    margin-left: 0 !important;
    color: #66b1ff;
    margin: 15px 0 0 0;
    display: inline-block;
  }
  .el-dialog__body {
    padding: 0 20px 20px 20px;
  }
  .el-dialog__header {
    padding: 14px;
    background: #009e7d;
    text-align: center;
    color: #fff;
    .el-dialog__title {
      color: #fff;
    }
    .el-icon-close {
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// createPicture.vue?b4f8fa88